export default __webpack_public_path__ + "static/media/image.groceries-lk.a7822b90.png";